<div class="dashboard-layout">
  <!-- Mobile Sidebar Overlay -->
  <p-drawer
    [(visible)]="sidebarVisible"
    position="left"
    [modal]="true"
    [showCloseIcon]="false"
    styleClass="mobile-sidebar"
    (onHide)="onSidebarHide()"
    *ngIf="isMobile">
    <app-dashboard-sidebar
      [isMobile]="true"
      (menuItemClick)="onSidebarHide()">
    </app-dashboard-sidebar>
  </p-drawer>

  <!-- Desktop Sidebar -->
  <aside class="sidebar-desktop" *ngIf="!isMobile">
    <app-dashboard-sidebar [isMobile]="false"></app-dashboard-sidebar>
  </aside>

  <!-- Main Content Area -->
  <div class="main-content" [class.mobile]="isMobile">
    <!-- Top Bar -->
    <app-dashboard-topbar
      [isMobile]="isMobile"
      (sidebarToggle)="toggleSidebar()">
    </app-dashboard-topbar>

    <!-- Page Content -->
    <main class="page-content">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
